import { render, staticRenderFns } from "./GoogleMegaboardBanner.vue?vue&type=template&id=59f81bc4&"
import script from "./GoogleMegaboardBanner.vue?vue&type=script&lang=js&"
export * from "./GoogleMegaboardBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports